import type { BitmapText, Point } from 'pixi.js';

/*
 * This is a workaround because PIXI.BitmapText.anchor has wrong typing (it allows number while it is always a point),
 * therefore we need this function to easily access and set anchor to BitmapText.
 * We don't use text.anchor = new Point(x, y) sice instantiating new point is unnecessary overhead, neither we use such
 * workaround for other element types since they have correct typing.
 */
export function getBitmapTextAnchor(bmText: BitmapText): Point {
  // hopefully it is really a Point: https://www.html5gamedevs.com/topic/40638-error-set-anchor-bitmaptext/
  return bmText.anchor as Point;
}
